import React from "react";

class Verification extends React.Component {
  constructor(props) {
    super(props);
  }

  renderOtpInputs = (className, setOtp, otp) =>
    Array.from({ length: 6 }).map((_, idx) => (
      <input
        key={idx}
        type="text"
        className={className}
        value={otp[idx]}
        placeholder=""
        maxLength={1}
        onInput={(e) => {
          if (!/^\d*$/.test(e.target.value)) {
            e.target.value = e.target.value.replace(/\D/g, "");
          }
          setOtp(idx, e.target.value);
          if (e.target.nextSibling && e.target.value) {
            e.target.nextSibling.focus();
          }
        }}
         onKeyDown={(e) => {
          if (
            e.key === "Backspace" &&
            !e.target.value &&
            e.target.previousSibling
          ) {
            e.target.previousSibling.focus();
            setOtp(idx - 1, "");
          }
        }}
        onPaste={(e) => {
          e.preventDefault();
          const pasted = e.clipboardData.getData("text").replace(/\D/g, "");
          if (!pasted) return;

          const newOtp = [...otp];
          for (let i = 0; i < 6; i++) {
            newOtp[i] = pasted[i] || "";
          }
          setOtp(null, newOtp); 
        }}
      />
    ));

  render() {
    const {
      email,
      otp,
      otpExpired,
      timer,
      handleInputChange,
      handleChangeStep,
      onOtpSend,
      setTimer,
      styles,
      onResendOtp
    } = this.props;

    return (
      <div className={styles.email_otp}>
        <div className={styles.email_otp__background}>
          <div className={styles.email_otp__content}>
            <div className={styles.email_otp__form_header}>
              <div className={styles.email_otp__icon}>
                <img src="images/mail.svg" alt="mail" />
              </div>
              <h2 className={styles.email_otp__form_title}>Check your email</h2>
              <p className={styles.email_otp__form_description}>
                We’ve just sent your email verification code to{" "}
                <span className={styles.highlight}>{email}</span>
              </p>
            </div>
            <div className={styles.email_otp__otp_main_container}>
              <div className={styles.email_otp__otp_container}>
                {this.renderOtpInputs(styles.otp_input, handleInputChange, otp)}
              </div>

              <div className={styles.email_otp__submit_container}>
                <button
                  className={`${styles.email_otp__submit_btn} ${
                    otp.some((digit) => digit === "")
                      ? styles.email_otp__submit_btn_disabled
                      : ""
                  }`}
                  onClick={onOtpSend}
                  disabled={otp.join("").length < 6}
                >
                  Verify OTP
                </button>
              </div>
              <div className={styles.email_otp__footer}>
                <span
                  className={styles.email_otp__change_email}
                  onClick={() => handleChangeStep("changeEmail")}
                >
                  Change email
                </span>
                <p className={styles.email_otp__timer}>
                  OTP code expired in <span className={styles.email_otp__timer_count}>{timer}{" "}</span>
                  <span
                    className={
                      timer === "0:00"
                        ? styles.email_otp__resend_enabled
                        : styles.email_otp__resend_disabled
                    }
                    // disabled={!otpExpired}
                    onClick={timer !== "0:00" ? null : onResendOtp}
                  >
                    Resend OTP code
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Verification;
